import { useState, useRef, useEffect } from "react";
import { faqs } from "@/mocks/celesteTarot";

export default function FaqSection() {
  const [openId, setOpenId] = useState<number | null>(null);
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.15 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  const toggle = (id: number) => setOpenId(openId === id ? null : id);

  return (
    <section id="preguntas-frecuentes" className="py-24 md:py-32 bg-[#faf7f2]">
      <div className="max-w-4xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-[#C9A84C] text-sm tracking-[0.3em] uppercase mb-4" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            Resolvemos tus dudas
          </p>
          <h2
            className="text-4xl md:text-5xl font-light text-[#1a1208]"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            Preguntas <span className="italic text-[#C9A84C]">Frecuentes</span>
          </h2>
        </div>

        {/* Accordion */}
        <div
          ref={ref}
          className={`flex flex-col gap-3 transition-all duration-1000 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
          }`}
        >
          {faqs.map((faq) => (
            <div
              key={faq.id}
              className="bg-white rounded-xl border border-[#e8dcc8] overflow-hidden"
            >
              <button
                onClick={() => toggle(faq.id)}
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer group"
              >
                <span
                  className="text-[#1a1208] text-base font-medium group-hover:text-[#C9A84C] transition-colors duration-200"
                  style={{ fontFamily: "'Cormorant Garamond', serif" }}
                >
                  {faq.question}
                </span>
                <span className="w-6 h-6 flex items-center justify-center text-[#C9A84C] flex-shrink-0 ml-4">
                  <i className={`text-lg transition-transform duration-300 ${openId === faq.id ? "ri-subtract-line rotate-180" : "ri-add-line"}`}></i>
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-400 ${
                  openId === faq.id ? "max-h-60 opacity-100" : "max-h-0 opacity-0"
                }`}
              >
                <p className="px-6 pb-5 text-[#5a4a35] text-sm leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
